import {useTheme} from "@emotion/react";
import {useRouteLoaderData} from "@remix-run/react";
import ContentCard from "@/elements/ContentCard";
import TitleUnderlinedAnimated from "@/elements/TitleUnderlinedAnimated";
import type {SectionCrossContenu} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import {CardsWrapper, InnerWrapper} from "./styles";

interface B12CrossContentProps {
  sectionData: SectionCrossContenu;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  id?: string;
}

const B12CrossContent = ({
  sectionData,
  isFirstSection,
  isLastSection,
  id,
}: B12CrossContentProps) => {
  const {breakpoints} = useTheme();
  const {isMobile, isDesktop, xl} = breakpoints;
  const {bg_color, posts, title} = sectionData;
  // The texts come with the shell, which the root loader sends once (the loaders of the preview routes carry none)
  const root = useRouteLoaderData("root") as RouteLoaderData | undefined;

  const localizedTitle =
    title || root?.translation?.crossContentTitle || "You might also like";

  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
    >
      {posts && (
        <InnerWrapper>
          <TitleUnderlinedAnimated
            // biome-ignore lint/suspicious/noExplicitAny: TitleUnderlinedAnimated.maxWidth est typé string mais une valeur numérique (px) est nécessaire au rendu mobile ; élargir ce prop est hors scope (app/elements/)
            maxWidth={(isMobile ? 300 : "auto") as any}
            styles={{fontSize: "2rem", lineHeight: "2.5rem"}}
          >
            {localizedTitle}
          </TitleUnderlinedAnimated>
          <CardsWrapper>
            {posts?.map((card) => (
              <ContentCard
                key={card.ID}
                cardData={card}
                imageLayout="cardGrid"
                styles={{
                  aspectRatio: isMobile ? "359/438" : "inherit",
                  height: isDesktop && !xl ? 460 : "auto",
                }}
              />
            ))}
          </CardsWrapper>
        </InnerWrapper>
      )}
    </SectionWrapper>
  );
};

export default B12CrossContent;
